module.exports = __webpack_public_path__ + "jp.4187b1d4.svg";